import { render, staticRenderFns } from "./BaseMultiSelect.vue?vue&type=template&id=49548888&scoped=true"
import script from "./BaseMultiSelect.vue?vue&type=script&lang=js"
export * from "./BaseMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseMultiSelect.vue?vue&type=style&index=0&id=49548888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49548888",
  null
  
)

export default component.exports